var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPurchasingIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 58,
  height: 58
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Purchasing Icon",
  transform: "translate(-61)"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 1",
  cx: 29,
  cy: 29,
  r: 29,
  transform: "translate(61)",
  fill: "#4e4e4e"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Icon awesome-shopping-cart",
  d: "m101.021 31.147 2.24-9.854a1.137 1.137 0 0 0-1.109-1.389H83.543l-.434-2.124a1.137 1.137 0 0 0-1.114-.909h-4.858A1.137 1.137 0 0 0 76 18.008v.763a1.137 1.137 0 0 0 1.137 1.132h3.311l3.328 16.268a2.653 2.653 0 1 0 3.176.406h9.932a2.652 2.652 0 1 0 3.013-.493l.261-1.15a1.137 1.137 0 0 0-1.109-1.389H86.334l-.31-1.516h13.888a1.137 1.137 0 0 0 1.109-.882Z",
  fill: "#fff"
}))));
export default SvgPurchasingIcon;